module.exports = __webpack_public_path__ + "static/media/rewards_premium_suscribed.4485cce8.png";